import {
  Backdrop,
  Box,
  CircularProgress,
  Grid,
  IconButton,
  ListItem,
  Menu,
  MenuItem,
  Typography,
  useTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { CiFileOn } from "react-icons/ci";
import { TfiMoreAlt } from "react-icons/tfi";
import { Enumerations } from "../../config/Enumerations";
import { GoEye } from "react-icons/go";
import { FiDownload } from "react-icons/fi";
import { AppEntryDocRepository } from "../repositories/AppEntryDocRepository";
import PDFDialogViewer from "./PDFDialogViewer";
import InfoAlert from "../common/InfoAlert";

const options = [
  { key: "preview", label: "Преглед", icon: <GoEye size={18} /> },
  { key: "download", label: "Преземи", icon: <FiDownload size={18} /> },
];

export default function EntryDecisions({ appEntry }) {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [menuAnchor, setMenuAnchor] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [menuOptions, setMenuOptions] = useState([]);
  const [pdfBlob, setPdfBlob] = useState(null);
  const [openPdfDialog, setOpenPdfDialog] = useState(false);
  const [saving, setSaving] = useState(false);

  const handleMenuClick = (event, fileName) => {
    setMenuAnchor(event.currentTarget);
    setSelectedFile(fileName);

    const filtered = options.filter((option) => {
      if (fileName.includes("-signed") && option.key === "sign") {
        return false;
      }
      return true;
    });
    setMenuOptions(filtered);
  };

  const handleMenuClose = () => {
    setMenuAnchor(null);
    setSelectedFile(null);
  };

  const getByFileName = (fileName) => {
    AppEntryDocRepository.getDocument(appEntry?.id, fileName, {
      responseType: "blob",
    })
      .then((res) => {
        setPdfBlob(res.data);
        setOpenPdfDialog(true);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const downloadByFileName = (fileName) => {
    setSaving(true);
    AppEntryDocRepository.getDocument(appEntry?.id, fileName, {
      responseType: "blob",
    })
      .then((res) => {
        setSaving(false);
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      })
      .catch((err) => {
        setSaving(false);
        console.log(err);
      });
  };

  return (
    <React.Fragment>
      <Grid container className="review-decisions-container" sx={{ p: 2 }}>
        <Grid item xs={12}>
          <div className="other-documents-header no-bottom-padding">
            <div className="other-documents-title-container">
              <div className="other-documents-title">
                <Typography variant="h6" className="title-text">
                  Одлуки
                </Typography>
              </div>
            </div>
          </div>
        </Grid>
        <Grid item xs={12}>
          {appEntry?.docs?.filter(
            (doc) =>
              doc.documentType === "DECISION_MVR_SIGNED" ||
              doc.documentType === "DECISION_JPDP_SIGNED",
          )?.length > 0 && (
            <Box className="other-documents-box">
              {appEntry?.docs
                ?.filter(
                  (doc) =>
                    doc.documentType === "DECISION_MVR_SIGNED" ||
                    doc.documentType === "DECISION_JPDP_SIGNED",
                )
                .map((doc, index) => (
                  <ListItem key={index} className="document-item dark-border">
                    <div className="document-icon">
                      <CiFileOn color="#2d2d2d" size={25} />
                    </div>
                    <div className="document-details">
                      <Typography
                        variant="inherit"
                        className="document-name dark"
                      >
                        {Enumerations.DocumentType[doc.documentType] ||
                          doc.documentType}
                      </Typography>
                    </div>
                    <div className="document-actions">
                      <IconButton
                        disableRipple
                        aria-label="more"
                        id="long-button"
                        aria-controls={open ? "long-menu" : undefined}
                        aria-expanded={open ? "true" : undefined}
                        aria-haspopup="true"
                        onClick={(e) => handleMenuClick(e, doc.fileName)}
                      >
                        <TfiMoreAlt
                          size={20}
                          color={theme.palette.secondary.main}
                        />
                      </IconButton>
                      <Menu
                        id="long-menu"
                        anchorEl={menuAnchor}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "right",
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "right",
                        }}
                        open={Boolean(menuAnchor)}
                        onClose={handleMenuClose}
                        slotProps={{
                          paper: {
                            style: {
                              width: "20ch",
                              boxShadow:
                                "rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px",
                            },
                          },
                          list: {
                            "aria-labelledby": "long-button",
                          },
                        }}
                      >
                        {menuOptions.map((option) => (
                          <MenuItem
                            key={option.label}
                            disableRipple
                            onClick={() => {
                              if (option.key === "preview") {
                                getByFileName(selectedFile);
                              } else if (option.key === "download") {
                                console.log(selectedFile);
                                downloadByFileName(selectedFile);
                              }
                              handleMenuClose();
                            }}
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "flex-start",
                              gap: "10px",
                              margin: "1px 5px",
                              borderRadius: "4px",
                              "&:hover": {
                                backgroundColor: "#eaf5ff",
                              },
                            }}
                          >
                            {option.icon}
                            <Typography
                              variant="subtitle2"
                              style={{ fontSize: "14px" }}
                            >
                              {option.label}
                            </Typography>
                          </MenuItem>
                        ))}
                      </Menu>
                    </div>
                  </ListItem>
                ))}
            </Box>
          )}
          {appEntry?.docs?.filter(
            (doc) =>
              doc.documentType === "DECISION_MVR" ||
              doc.documentType === "DECISION_JPDP",
          ).length === 0 && (
            <div style={{ padding: "10px 0", width: "100%", display: "flex" }}>
              <InfoAlert message="Сè уште нема донесени одлуки за ова барање." />
            </div>
          )}
        </Grid>
      </Grid>
      <PDFDialogViewer
        openPdfDialog={openPdfDialog}
        setOpenPdfDialog={setOpenPdfDialog}
        pdfBlob={pdfBlob}
      />
      {saving && (
        <Backdrop open={true} sx={{ zIndex: 9999, color: "#fff" }}>
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
    </React.Fragment>
  );
}
